/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Level_WarningInputs */



/**
* | output |
* | --- |
* | "Warning" |
*
* @param {Sanction_Level_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_level_warning = /** @type {((inputs?: Sanction_Level_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Level_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Alerte")
	if (locale === "es") return /** @type {LocalizedString} */ ("Advertencia")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aviso")
	if (locale === "it") return /** @type {LocalizedString} */ ("Richiamo")
	return /** @type {LocalizedString} */ ("Warning")
});